<template>
  <div class="single-simple-player-con" @click.stop="tooglePaly">
    <img v-show="loading" src="@/assets/images/free-practice/loading.svg" class="loading-icon" />
    <img
      v-show="!loading && playing"
      src="@/assets/images/free-practice/pause-audio.svg"
      class="pause-icon"
    />
    <img
      v-show="!loading && !playing"
      src="@/assets/images/free-practice/play.svg"
      class="play-icon"
    />
    <svg v-show="!loading" viewBox="22 22 44 44" class="prograss-con">
      <circle
        id="play-progress"
        cx="44"
        cy="44"
        :r="progressR"
        fill="none"
        stroke="#fff"
        stroke-width="3.6"
      ></circle>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    soundUrl: {
      type: String,
      default: '',
    },
  },
  watch: {
    soundUrl() {
      //切换地址，停止播放
      this.$player.stop()
      this.progress = 0
      this.setProgress(0)
    },
  },
  mounted() {
    this.progress = 0
    this.setProgress(0)
    this.$player.setPlayClass = (e) => {
      if (e && e == 'play') {
        this.playing = true
      } else {
        this.playing = false
      }
    }
  },
  data() {
    return {
      beforeFn: null,
      progress: 0,
      loading: false,
      playing: false,
      progressR: 19.5,
    }
  },
  methods: {
    setProgress(percent) {
      let dom = document.getElementById('play-progress')
      const perimeter = 2 * Math.PI * this.progressR
      const offset = perimeter - (percent / 100) * perimeter
      if (dom) {
        dom.style.strokeDasharray = perimeter
        dom.style.strokeDashoffset = offset
      }
    },
    onStep() {
      if (!this.soundUrl) return
      let seek = 0
      try {
        seek = this.$player.sound.seek()
      } catch (e) {
        console.log(e)
      }
      this.progress = ((seek / this.$player.sound.duration()) * 100).toFixed(1)
      this.setProgress(this.progress)
      if (this.playing) {
        requestAnimationFrame(() => {
          this.onStep()
        })
      }
    },
    tooglePaly() {
      var soundUrl = this.soundUrl || ''
      if (soundUrl == this.$player.file) {
        // 正在播放进程中
        if (this.playing) {
          this.$player.sound.pause()
        } else {
          this.$player.sound.play()
          this.playing = true
          this.onStep()
          this.setProgress()
        }
      } else {
        // 新地址初始化播放
        this.loading = true
        this.$player.play(soundUrl, '', {}, false, false, false)
        this.$player.onloaded = (e) => {
          this.playing = true
          this.onStep()
          this.loading = false
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.single-simple-player-con {
  cursor: pointer;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background: #5f9595;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  position: relative;
  color: #fff;
  .loading-icon {
    width: 24px;
    height: 24px;
    animation-name: spin;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  .pause-icon {
    width: 24px;
    height: 24px;
  }
  .play-icon {
    width: 9px;
    margin-left: 3px;
  }
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
.simple-player-con::after {
  content: '';
  position: absolute;
  top: 0;
  width: 0;
  background: transparent;
  width: 32px;
  height: 32px;
}
.prograss-con {
  width: 30px;
  height: 30px;
  position: absolute;
  transform: rotate(-90deg);
}
// .simple-player-con:hover &.simple-player-con::after {
//   background: rgba(0, 0, 0, 0.1);
// }
</style>
